<template>
  <div />
</template>

<script>
export default {
  name: 'TicketDetailRoute',
  created() {
    const caseNo = this.$route.params.caseNo;
    // Deep link to /tickets/:caseNo -> redirect to /tickets?caseNo=... to open the detail dialog.
    this.$router.replace({ path: '/tickets', query: { ...this.$route.query, caseNo } });
  }
};
</script>

